import { Funnel } from 'types/state'

export const getFunnelFromWindowLocation = () => {
  if (typeof window !== 'undefined') {
    const path = window.location.pathname
    return Object.values(Funnel).find((funnelValue) => {
      const funnelMatchRegex = new RegExp(`^(/[a-z]{2})?/${funnelValue}(?:/|$)`)
      return funnelMatchRegex.test(path)
    })
  }

  return undefined
}
